import { Dispatch, SetStateAction } from 'react';
import {
  getUsersNotVotation,
  postInviteVotation,
} from 'services/indexcServices';

export const getNPSStatus = async (
  setDynamicUrl: Dispatch<SetStateAction<string>>
): Promise<boolean> => {
  const email = localStorage.getItem('@UltragazEmpresarial:loginEmail') || '';
  const nome = localStorage.getItem('@UltragazEmpresarial:userName') || '';
  const telefone = localStorage.getItem('@UltragazEmpresarial:phone') || '';

  const response = await getUsersNotVotation(email);
  const isPostNPS = false;

  if (response.invites.length === 0 && isPostNPS) {
    const responsePost = await postInviteVotation(nome, email, telefone);
    const shortUrl = responsePost?.customers[0]?.shortUrl
      ? `${responsePost?.customers[0]?.shortUrl}-L`
      : '';
    setDynamicUrl(shortUrl);
    return !!responsePost?.customers[0]?.shortUrl;
  }

  if (response.invites.length > 0) {
    const isSent =
      response.invites[response.invites.length - 1].status === 'enviado';

    const shortUrl = response.invites[response.invites.length - 1]?.shortUrl
      ? `${response.invites[response.invites.length - 1]?.shortUrl}-L`
      : '';

    setDynamicUrl(shortUrl);

    return isSent;
  }
  return false;
};
